import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuthStore } from "@/shared/lib/auth-store";

export function ProtectedRoute(): JSX.Element {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
